export default {
    TABLE: 'table',
    CHART: 'chart'
};
